import React from 'react'
import { useNavigate } from 'react-router-dom'
import WTPPreventiveDataCard from './WTPPreventiveDataCard'


export default function WTPPreventiveDataCardManage(props) {
    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName, DashProjectTypeId,WTPMasterCountData } = props

    const PreventiveWorkNavigate = (name, screenFlag) => {
        if (name === "Pump House") {
            navigate(`/wtppreventivepumphousepage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Pure Water Pumping Station") {
            navigate(`/wtppreventivepurewaterpumpingstationpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Pressure Monitoring") {
            navigate(`/wtppreventivepressuremonitoringpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Machinery Checklist") {
            navigate(`/wtppreventivemachinerychecklistpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Backwashing") {
            navigate(`/wtppreventivebascwashingpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Operational Work") {
            navigate(`/wtppreventiveoperationalworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Security") {
            navigate(`/wtppreventivesecuritypage?ScreenName=Security&name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "House Keeping") {
            navigate(`/wtppreventivesecuritypage?ScreenName=House Keeping&name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Recirculation of Pump") {
            navigate(`/wtppreventiverecirculationofpumppage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Distribution Network") {
            navigate(`/watersupplydistributionnetworkpreventiveworkpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
    }
    const navigate = useNavigate()
    // console.log('DashProjectTypeId',DashProjectTypeId)
    return (
        <div>
            <div className="row">
                <h5 className="ml-4 py-2">Preventive Data</h5>
            </div>
            <div className="row pr-3 pl-3">
                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WTPPreventiveDataCard
                        title="Pump House"
                        imgPath='./assets/img/waterpressure.png'
                        count={WTPMasterCountData?.PumpHouseTotalCount ? WTPMasterCountData?.PumpHouseTotalCount : '0'}
                    // count={Countdata?.WaterPressureTotalCount}
                    // navLink='/waterpressurepreventiveworkpage'
                    PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WTPPreventiveDataCard
                        title="Pure Water Pumping Station"
                        imgPath='./assets/img/water-waves.png'
                        count={WTPMasterCountData?.PureWaterPumpingStationTotalCount ? WTPMasterCountData?.PureWaterPumpingStationTotalCount : '0'}
                    // count={Countdata?.WaterFlowTotalCount}
                    // navLink='/waterflowpreventiveworkpage'
                    PreventiveWorkNavigate={PreventiveWorkNavigate}

                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WTPPreventiveDataCard
                        title="Pressure Monitoring"
                        imgPath='./assets/img/waterpressure.png'
                        count={WTPMasterCountData?.PressureMonitoringTotalCount ? WTPMasterCountData?.PressureMonitoringTotalCount : '0'}
                    // navLink='/waterquantitypreventiveworkpage'
                    PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WTPPreventiveDataCard
                        title="House Keeping"
                        imgPath='./assets/img/house-keeping.png'
                        count={WTPMasterCountData?.HouseKeepingTotalCount ? WTPMasterCountData?.HouseKeepingTotalCount : '0'}
                    // navLink='/chemicalsupplypreventiveworkpage'
                    PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WTPPreventiveDataCard
                        title="Recirculation of Pump"
                        imgPath='./assets/img/pump1.png'
                        count={WTPMasterCountData?.RecirculationOfPumpTotalCount ? WTPMasterCountData?.RecirculationOfPumpTotalCount : '0'}
                    // count={Countdata?.WaterAuditTotalCount}
                    // navLink='/waterauditpreventiveworkpage'
                    PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WTPPreventiveDataCard
                        title="Machinery Checklist"
                        imgPath='./assets/img/Machinery-Checklist.png'
                        count={WTPMasterCountData?.MachineryChecklistTotalCount ? WTPMasterCountData?.MachineryChecklistTotalCount : '0'}
                    // count={Countdata?.EnergyConsumptionTotalCount}
                    // navLink='/energyconsumptionpreventiveworkpage'
                    PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WTPPreventiveDataCard
                        title="Security"
                        imgPath='./assets/img/security.png'
                        count={WTPMasterCountData?.SecurityTotalCount ? WTPMasterCountData?.SecurityTotalCount : '0'}
                    // count={Countdata?.SecurityTotalCount}
                    // navLink='/watersecuritypreventiveworkpage'
                    PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WTPPreventiveDataCard
                        title="Backwashing"
                        imgPath='./assets/img/house-cleaning.png'
                        count={WTPMasterCountData?.BackWashingTotalCount ? WTPMasterCountData?.BackWashingTotalCount : '0'}
                    // count={Countdata?.HouseKeepingTotalCount}
                    // navLink='/waterhousekeepingpreventiveworkpage'
                    PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-2 mb-2 water_pre_work_width">
                    <WTPPreventiveDataCard
                        title="Operational Work"
                        imgPath='./assets/img/operational-system.png'
                        count={WTPMasterCountData?.OperationalWorkTotalCount ? WTPMasterCountData?.OperationalWorkTotalCount : '0'}
                    // count={Countdata?.ValveOperationTotalCount}
                    // navLink='/watervalveoperationpreventiveworkpage'
                    PreventiveWorkNavigate={PreventiveWorkNavigate}
                    />
                </div>

            </div>

        </div>

    )

}
